import React from 'react'
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const EngagementGDProspekt = () => {
  return (
    <div className="container mt-1 text-center">
      <motion.div
        className="announcement bg-light p-4 rounded shadow-lg responsive-fs"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        style={{ maxWidth: "650px" }}
      >
        <img
          src="/images/projekte/engagement/EngagementGDProspekt.jpeg"
          alt="Engagement"
          className="img-fluid rounded mb-3"
        />
        <h2 className="fw-bold text-success fs-5 fs-md-1">
          <Link
            to="/engagementGlobale"
            className="text-decoration-none"
            style={{
              color: "#28a745", // Başlangıçtaki renk
              fontWeight: "bold",
              transition: "all 0.3s ease-in-out", // Animasyon ekledik
            }}
            onMouseEnter={(e) => {
              e.target.style.color = "#0056b3"; // Hover rengi
              e.target.style.textDecoration = "underline"; // Hoverda alt çizgi
            }}
            onMouseLeave={(e) => {
              e.target.style.color = "#28a745"; // Başlangıç rengi
              e.target.style.textDecoration = "none"; // Alt çizgiyi kaldırıyoruz
            }}
          >
            Zum Detail
          </Link>
        </h2>
      </motion.div>
    </div>
  );
}

export default EngagementGDProspekt
